import React, { ComponentProps } from 'react';
import { DeletableItemList } from '../../../_lib/components/DeletableItemList/DeletableItemList';
import ILink from '../../../types/ILink';
import IForm from '../../../types/IForm';
import { ContentLink } from '../../../_lib/components/ContentLink';
import { asFetchableView } from '../../../_lib/ViewFetcher';
import { useInvalidateRefreshableBlock, useRefreshBlockInDefaultView } from '../../../_lib/BlockFetcher';
import { Namespace } from '../../../translation/namespace';
import { BlockType } from '../../../types/api/ElementType';

type EditViewProps = {
  items: {
    id: string;
    content: {
      pageLink: ILink;
    };
    removeForm: IForm;
  }[];
};

function WatchedPageMessagesEdit({ items }: EditViewProps) {
  const { refresh } = useRefreshBlockInDefaultView();
  const invalidateRefreshableBlock = useInvalidateRefreshableBlock();

  return (
    <DeletableItemList
      items={items.map(item => ({ name: item.content.pageLink.name, ...item }))}
      refresh={() => {
        refresh();
        invalidateRefreshableBlock(BlockType.pagemetainfo);
      }}
      namespaceAndKey={`${Namespace.WatchedPageMessagesPanel}:deletableItem`}
    >
      {item => (
        <ContentLink key={item.id} to={item.content.pageLink.url}>
          {item.content.pageLink.name}
        </ContentLink>
      )}
    </DeletableItemList>
  );
}

export const WatchedPageMessagesEditView = asFetchableView(WatchedPageMessagesEdit);
export type WatchedPageMessagesEditView = ComponentProps<typeof WatchedPageMessagesEditView>;
